import React from 'react'
import UserMenu from './UserMenu'
// import NotificationBell from './UserMenu/Notificaton'

// import Cart from './Cart'
import style from './style.module.scss'

const TopBar = () => {
  return (
    <div className={style.topbar}>
      {/* <NotificationBell /> */}
      <div className={` ml-4 custom-margin-left-2rem`}>
        {' '}
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
